import React, { useState, useEffect } from 'react';
import { userService } from "../../../_services";
import { ConfirmDialog } from "../../ui/confirm-dialog";
import { Alert, AlertDescription } from "../../ui/alert";

/**
 * Reset Group Number Modal
 * Modernized with shadcn Dialog component
 */
function Reset_group_Pop({ toggle_reset_popup, title, group_no, grouptype, username }) {
    const [pricingtool, setPricingtool] = useState(false);
    const [errormsg, setErrormsg] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check if group has pricing tool
        if (group_no) {
            checkPricingtool(group_no);
        }
    }, [group_no]);

    const checkPricingtool = async (groupno) => {
        try {
            const apidata = await userService.CheckPricingtool(groupno);
            if (apidata === true) {
                setPricingtool(true);
            }
        } catch (error) {
            console.error('Error checking pricing tool:', error);
        }
    };

    const reset_group = async () => {
        setErrormsg('');
        setLoading(true);
        
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [userId, userName] = Usermeta_Data.split(':');
            
            const apidata = await userService.resetgroup(userId, userName, group_no);
            
            if (apidata && apidata.length > 0) {
                if (apidata[0].code === '1') {
                    // Success - close modal and refresh list
                    toggle_reset_popup({ stopPropagation: () => {}, currentTarget: null }, true);
                } else {
                    setErrormsg('Please try again');
                }
            }
        } catch (error) {
            setErrormsg('An error occurred. Please try again.');
            console.error('Error resetting group:', error);
        } finally {
            setLoading(false);
        }
    };

    const reset__primary_group = async () => {
        setLoading(true);
        
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [userId, userName] = Usermeta_Data.split(':');
            
            const apidata = await userService.resetprimarygroup(userId, userName, group_no, username);
            
            if (apidata && apidata.length > 0) {
                if (apidata[0].code === '1') {
                    // Success - close modal and refresh list
                    toggle_reset_popup({ stopPropagation: () => {}, currentTarget: null }, true);
                }
            }
        } catch (error) {
            console.error('Error resetting primary group:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        // Close without refresh
        toggle_reset_popup({ stopPropagation: () => {}, currentTarget: null }, false);
    };

    // Determine if this is a primary group
    const isPrimaryGroup = grouptype === 'true';

    // Get appropriate description based on group type
    const getDescription = () => {
        if (isPrimaryGroup) {
            return "Primary group numbers cannot be reset. Please reach out to your system administrator for more assistance.";
        } else if (pricingtool) {
            return "Are you sure you want to reset this group number? All distributor details, commission values and overrides will be removed from this group number. The pricing tool/deeplink will also be deactivated.";
        } else {
            return "Are you sure you want to reset this group number? All distributor details, commission values and overrides will be removed from this group number.";
        }
    };

    return (
        <ConfirmDialog
            open={true}
            onOpenChange={handleClose}
            title={title}
            description={getDescription()}
            onConfirm={isPrimaryGroup ? reset__primary_group : reset_group}
            onCancel={handleClose}
            confirmText={isPrimaryGroup ? "Contact Administrator" : "Yes"}
            cancelText={isPrimaryGroup ? "Close" : "No"}
            variant={isPrimaryGroup ? "default" : "warning"}
            loading={loading}
            showIcon={true}
        >
            {errormsg && (
                <Alert variant="destructive">
                    <AlertDescription>{errormsg}</AlertDescription>
                </Alert>
            )}
        </ConfirmDialog>
    );
}

export default Reset_group_Pop;
